function CPRSectionModel(section) {
    if (!section) section = {};
    var model = {};

    model.Period = section.Period;

    model.CostCenters = [];
    for (var i = 0; i < section.CostCenters.length; i++) {
        model.CostCenters.push(new CPRCostCenterModel(section.CostCenters[i]));
    }

    model.YearTotal = function () {
        var _yeartotal = {};
        _yeartotal.AmountFullClaimsCosts = 0;
        _yeartotal.AmountClaimsCosts = 0;
        _yeartotal.AmountRecoveryAmount = 0;
        _yeartotal.AmountGrossClaimsCosts = 0;
        _yeartotal.AmountTotal = 0;
        _yeartotal.TotalNumberString = "";
        _yeartotal.totalNumber = 0;
        _yeartotal.totalClosed = 0;
        model.CostCenters.forEach(function (costcenter) {
            var siteTotal = costcenter.SiteTotal();
            _yeartotal.AmountFullClaimsCosts += parseFloat(siteTotal.AmountFullClaimsCosts);
            _yeartotal.AmountClaimsCosts += parseFloat(siteTotal.AmountClaimsCosts);
            _yeartotal.AmountRecoveryAmount += parseFloat(siteTotal.AmountRecoveryAmount);
            _yeartotal.AmountGrossClaimsCosts += parseFloat(siteTotal.AmountGrossClaimsCosts);
            _yeartotal.AmountTotal += parseFloat(siteTotal.AmountTotal);
            _yeartotal.totalNumber += parseFloat(siteTotal.totalNumber);
            _yeartotal.totalClosed += parseFloat(siteTotal.totalClosed);
        });
        _yeartotal.totalOpen = _yeartotal.totalNumber - _yeartotal.totalClosed;
        _yeartotal.TotalNumberString = _yeartotal.totalNumber + " claim(s), " + _yeartotal.totalOpen + " open, " + _yeartotal.totalClosed + " closed.";
        return _yeartotal;
    }

    return model;
}